import { inject } from '@angular/core';

import { COMPANY_ID } from '@core/common-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { CareersSubdomain } from '@recruitee/careers-site-types';

export const getPastDomainsScopeKey = () => {
  const companyId = inject(COMPANY_ID);
  return `past-subdomain:company:${companyId}`;
};
const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<CareersSubdomain>()('CareersSiteSubdomains');

export {
  actions as CareersSiteSubdomainActions,
  selectors as CareersSiteSubdomainSelectors,
  reducer as CareersSiteSubdomainReducer,
  namespace as CareersSiteSubdomainNamespace,
};
